export default __webpack_public_path__ + "static/media/potentiometer.6b16c06a.jpg";